import fileDownload from 'js-file-download';
// import { saveAs } from 'file-saver';
import { CODE_RESPONSE, ASYNC_STATUS } from '../../constants/async/statuses';
import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from '@reduxjs/toolkit';

import { STATUS } from 'constants/thunkStates';
import { OPERATION_STATUS } from 'constants/operationStatus';
import { getFilters, getFiltersForLinks } from 'utils/helpers';
import { BUCKET } from 'constants/index';
import moment from 'moment';

const filesInitialState = {
  status: STATUS.idle,
  error: null,
  files: null,
};

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const asyncRequest = async (payload, rejectWithValue, extra, requestType, errorMessage) => {
  let valueAsync = true;
  let response = await extra.API.backoffice[requestType](payload, valueAsync);

  if (!response.task) return rejectWithValue({ message: 'No se pudo subir y/o guardar la informacion correctamente' });

  const requestId = response.task.id

  while (response.task.status.id === ASYNC_STATUS.awaiting) {
    await sleep(4000)
    response = await extra.API.backoffice[requestType](payload, requestId);
    await sleep(4000)
  };
  if (response.task.status.id === ASYNC_STATUS.error || !response.task.status.id || response.task.result.code >= CODE_RESPONSE.error) {
    return rejectWithValue({ message: 'No se pudo subir y/o guardar la informacion correctamente' });
  };
  const result = {
    code: response.task.code ? response.task.code : CODE_RESPONSE.success,
    link: response.task.result
  }

  return result.code !== 200 ?
    rejectWithValue({ message: errorMessage }) :
    result;
}

const uploadFilePresigned = async (data, extra, rejectWithValue) => {
  const formData = new FormData();

  const dirname = 'massive_upload'

  const date = moment().format('YYYYMMDD');
  const timestamp = moment().valueOf();

  const filename = `uploadbulk_${date}_${timestamp}.csv`;

  const options = {
    idType: 2,
    bucket: BUCKET,
    dirname,
    filename,
    expiration: 900
  };

  try {
    //get presigned url
    const uploadFileUrl = await extra.API.backoffice.getPresignedUrl(options);

    const { id_file: idFile, url, fields } = uploadFileUrl;

    Object.keys(fields).forEach(key => {
      formData.append(key, fields[key]);
    });

    formData.append('file', data.file);
    //update file data in database
    const fileDataUpdate = await extra.API.backoffice.updatePresignedFile(idFile, fields);
    //upload file in s3
    await extra.API.backoffice.uploadFile(url, formData);

    return fileDataUpdate.description;
  }
  catch (error) {
    console.log({ error })
    return rejectWithValue({ message: 'No se pudo subir y/o guardar la informacion correctamente' });
  }
}

export const bulkAdd = createAsyncThunk(
  'files/bulkAdd',
  async (payload, { rejectWithValue, extra }) => {
    const fileUrl = await uploadFilePresigned(payload, extra, rejectWithValue);

    if (!fileUrl) {
      return rejectWithValue({ message: 'No se pudo subir y/o guardar la informacion correctamente' });
    }

    const data = {
      fileUrl,
      operationType: payload.operationType
    }
    if (payload.disabledSecurity) {
      data.disabledSecurity = payload.disabledSecurity;
    }

    return asyncRequest(
      data,
      rejectWithValue,
      extra,
      'bulkAdd',
      'No se pudo subir y/o guardar la informacion correctamente'
    )
  });

export const generateLinks = createAsyncThunk(
  'files/generateLinks',
  async (payload, { rejectWithValue, extra }) => {
    const filters = getFiltersForLinks(payload);
    return asyncRequest(
      filters,
      rejectWithValue,
      extra,
      'generateLinks',
      'Ocurrio un error al generar el archivo'
    )
  });

export const exportFile = createAsyncThunk(
  'files/exportFile',
  async (payload, { rejectWithValue, extra }) => {
    const filters = getFilters(payload);
    return asyncRequest(
      filters,
      rejectWithValue,
      extra,
      'exportFilteredOperations',
      'Ocurrio un error al generar el archivo'
    )
  });

export const downloadSuccess = createAsyncThunk(
  'files/downloadSuccess',
  async (payload, { extra }) => {

    const generateLinksResponse = await extra.API.backoffice.downloadSuccess(
      { fileId: payload.fileId }
    );
    return fileDownload(generateLinksResponse, `Contract-${payload.name}.pdf`);
  }
);

export const exportSuccessfulOperations = createAsyncThunk(
  'files/exportSuccessfulOperations',
  async (_, { extra }) => {
    const filters = {
      operationStatus: OPERATION_STATUS.success,
    };
    const exportOkOpResponse =
      await extra.API.backoffice.exportSuccessfulOperations(filters);
    return fileDownload(
      exportOkOpResponse,
      `SUCESSFUL_OPERATIONS-${Date.now()}.txt`
    );
  }
);



const isPendingAction = isPending(
  bulkAdd,
  generateLinks,
  exportFile,
  exportSuccessfulOperations
);
const isFulfilledAction = isFulfilled(
  bulkAdd,
  generateLinks,
  exportFile,
  exportSuccessfulOperations
);
const isRejectedAction = isRejected(
  bulkAdd,
  generateLinks,
  exportFile,
  exportSuccessfulOperations
);

const filesSlice = createSlice({
  name: 'files',
  initialState: filesInitialState,
  reducers: {
    resetState: (state, { payload }) => {
      state.status = STATUS.idle;
      state.error = null;
    },
    setError: (state, { payload }) => {
      state.status = STATUS.error;
      state.error = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isPendingAction, (state, { payload }) => {
      state.status = STATUS.pending;
    });
    builder.addMatcher(isRejectedAction, (state, action) => {
      const { payload, error } = action;
      state.status = STATUS.error;
      state.error = error.message || error || payload.message || payload;
    });
    builder.addMatcher(isFulfilledAction, (state, { payload }) => {
      state.status = STATUS.success;
    });
  },
});

export const { resetState, setError } = filesSlice.actions;

export default filesSlice;
